import { useState } from "react";
import styles from "./Tag.module.css";
const colors = [
  "#0056d2",
  "#3670a0",
  "#f72585",
  "#fb8500",
  "#b388eb",
  "#7209b7",
  "#8093f1",
];
export function Tag({ text }) {
  const [color] = useState(() => colors[Math.floor(Math.random() * 7)]);

  return (
    <label className={styles.tag} style={{ backgroundColor: color }}>
      {text}
    </label>
  );
}
